namespace TabAurous.Retail {
    export namespace SeasonalityService {
        export const baseUrl = 'POSSales/Seasonality';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "POSSales/Seasonality/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SeasonalityService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
